/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 静脈路確保部位(左右)
 */
export type TreatmentIVAccessSideEnum =
  (typeof TreatmentIVAccessSideEnum)[keyof typeof TreatmentIVAccessSideEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TreatmentIVAccessSideEnum = {
  RIGHT: 'RIGHT',
  LEFT: 'LEFT',
} as const;
